import Button from "../Button";

export const FILTER_TOGGLE_BUTTON_STATE = {
    ACTIVE: 'active',
    DEACTIVATED: 'deactivated',
    PASSIVE: 'passive'
}

export default ({ state=FILTER_TOGGLE_BUTTON_STATE.PASSIVE, className, children, ...restOfProps}) => {
    return (
        <Button className={`state-${state} ${className} ${children ? 'has-children' : ''}`} {...restOfProps}>
            {children}
        </Button>
    )
}